var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcnProfilo = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50.5 50.5",
    fill: "#fff",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "002-block-user",
    d: "M24.061 46.545H5.984a2 2 0 0 1-1.577-.75 2.06 2.06 0 0 1-.418-1.728 21.791 21.791 0 0 1 20.752-17.255c.167.006.334.01.5.01a13.424 13.424 0 1 0-8.023-2.671A25.647 25.647 0 0 0 .127 43.263a5.992 5.992 0 0 0 5.857 7.226h18.077a1.972 1.972 0 1 0 0-3.944zm-8.284-33.134a9.467 9.467 0 1 1 9.691 9.464 1.957 1.957 0 0 0-.224-.014c-.154 0-.309 0-.462.005a9.478 9.478 0 0 1-9.005-9.455zM46.148 33.76v-1.614a5.918 5.918 0 0 0-11.833 0v1.615a4.937 4.937 0 0 0-4.337 4.894v9.861a1.972 1.972 0 0 0 1.972 1.972h16.567a1.972 1.972 0 0 0 1.972-1.972v-9.862a4.937 4.937 0 0 0-4.341-4.894zm-5.917-3.486a1.927 1.927 0 0 1 1.969 1.872v1.578h-3.941v-1.578a1.926 1.926 0 0 1 1.973-1.872zm6.313 16.269H33.922v-7.889a.987.987 0 0 1 .986-.986h10.65a.988.988 0 0 1 .986.986zm0 0"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcnProfilo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icn_profilo.f4e1e61d.svg";
export { ForwardRef as ReactComponent };